import { FIRE_DEPARTMENT_IDS, LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Cleveland Fire Department": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/7140712780864ff2b37facb42458b148?v=9f6157b1b53d44dfb6248c55f26b2aaa",
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.OH.CLEVELAND_FIRE_DEPARTMENT,
          name: "Cleveland Public Safety",
        },
      ],
    },
    jurisdictionType: "City/County",
    state: "OH",
  },
  "Ohio Fee Worksheet": {
    parameters: {
      staffInputs: {
        fees: true,
        documentTypes: {
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    state: "OH",
  },
  "Ohio Certification Form": {
    parameters: {
      staffInputs: {
        documentTypes: {
          certification: true,
        },
      },
    },
    jurisdictionType: "State",
    state: "OH",
  },
  "Warren County Portal": {
    parameters: {
      linkUrls: ["https://tier2.erplan.net/onlinefiling/filingLogin.htm"],
      staffInputs: {
        fees: true,
        documentTypes: {
          report: true,
          invoice: true,
          receipt: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.OH.WARREN_COUNTY,
          name: "Warren County",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "OH",
    dependsOn: ["Tier2SubmitValidation"],
  },

  "City of Cleveland": {
    parameters: {
      linkUrls: ["https://www.notion.so/encamp/Cleveland-City-of-4a6bd97dd36b4de2a1930d85a16d7e85"],
      includeCities: ["Cleveland"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "OH",
  },
  "City of Wadsworth": {
    parameters: {
      linkUrls: ["https://webftp.wadsworthcity.com/"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.OH.WADSWORTH_FIRE_DEPARTMENT,
          name: "Wadsworth Fire Department",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "OH",
  },
};
